import React from "react";
import Box from '@mui/material/Box';
import { Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import StepConnector from '@mui/material/StepConnector';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import Check from '@mui/icons-material/Check';
import { StepIconProps } from '@mui/material/StepIcon';


const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.dark,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.dark,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.grey[500],
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));
const QontoStepIconRoot = styled('div')(
  ({ theme }) => ({
    color: theme.palette.grey[500], // Pending dor
    display: 'flex',
    height: 22,
    alignItems: 'center',
    '& .QontoStepIcon-completedIcon': {
      color: theme.palette.primary.dark, // Completed dot
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[700],
    }),
    variants: [
      {
        props: ({ ownerState }) => ownerState.active,
        style: {
          color: theme.palette.primary.main, // Active dot
        },
      },
    ],
  }),
);
function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

export default function ReleaseStatusMap(props) {
  const { status, release_date } = props;
  const [data, setData] = React.useState({ version: "unknown", release_date: "unknown" });

  React.useEffect(() => {
    let new_data = { release_date: release_date, stage: 0 };
    switch (status) {
      case "planned":
      case "branching":
        new_data.stage = 0;
        break;
      case "branched":
      case "testing":
        new_data.stage = 1;
        break;
      case "validating":
        new_data.stage = 2;
        break;
      case "releasing":
        new_data.stage = 3;
        break;
      case "released":
        new_data.stage = 4;
        break;
      default:
        new_data.stage = 0;
    }
    setData(new_data);

  }, [status, release_date]);

  return (
    <React.Fragment>
      {release_date !== undefined && release_date !== null &&
        <Box>
          <Typography >
            Released on {data.release_date}
          </Typography>
        </Box>
      }
      <Stack sx={{ width: '100%', }} spacing={4} direction="row" mt={4}>
        <Stepper alternativeLabel activeStep={data.stage} connector={<QontoConnector />} sx={{ width: '100%' }}>
          <Step key="1">
            <StepLabel StepIconComponent={QontoStepIcon}>Branching</StepLabel>
          </Step>
          <Step key="2">
            <StepLabel StepIconComponent={QontoStepIcon}>Test</StepLabel>
          </Step>
          <Step key="3">
            <StepLabel StepIconComponent={QontoStepIcon}>Validation</StepLabel>
          </Step>
          <Step key="4">
            <StepLabel StepIconComponent={QontoStepIcon}>Release</StepLabel>
          </Step>
        </Stepper>
      </Stack>

    </React.Fragment>
  );
};